import type {Schema} from 'schemaDefinition/types';
import type {CodeListMap} from 'services/codelists/types';
import {useCodelists} from 'services/codelists';
import {useSchemaCodelistIds} from './useSchemaCodelistIds';

/**
 * Assumes needed codelists have been loaded
 * @param schema
 * @returns
 */
export const useSchemaCodelists = (schema: Schema | undefined): CodeListMap => {
  const codelistIds = useSchemaCodelistIds(schema);
  return useCodelists(codelistIds);
};
